export default __webpack_public_path__ + "static/media/Blade's Breeches of the Grim Cabal.3d3df231.jpg";